<!--
 * @Author: zl
 * @Date: 2022-04-14 09:29:08
 * @LastEditTime: 2022-04-14 09:32:31
 * @LastEditors: zl
 * @Description: 审计统计
-->
<template>
	<div class="AuditStatistics-layout">
		<div class="tip">程序开发中，敬请期待!</div>
	</div>
</template>

<script>
export default {
	name: 'AuditStatisticsIndex',
	components: {},
	data() {
		return {}
	},
	created() {},
	methods: {},
	computed: {},
}
</script>
<style lang='less' scoped>
.AuditStatistics-layout {
	height: 100%;
	position: relative;
	.tip {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		font-size: 40px !important;
	}
}
</style>